

import Vue from 'vue'
import App from './App'
import router from './router'

import Cube from 'cube-ui'
import "normalize.css"
import store from './store/store'
import axios from 'axios'
import vueaxios from 'vue-axios';
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Vconsole from 'vconsole';
import VueDND from 'awe-dnd';
import packageConfig from '../package.json';
import './assets/iconfont/iconfont.css';

import {uploadLog,startLoading,endLoading} from './common/tools'
import VueCookies from 'vue-cookies';
import qs from 'qs';

console.log(VueCookies);
Vue.use(VueCookies);
Vue.$cookies.config('9999d');

const debugWithBuild=false;        
if(process.env.NODE_ENV==='development'){

}

Vue.config.productionTip = false;

if(debugWithBuild){
window.startTest=(level=1)=>{
store.dispatch('changeTestLevel',level-1).then(()=>{
router.push('/test');
});
}
}








window.enterUrl=location.href;

console.log(`version:${packageConfig.version}`);


import rem from './common/rem';
rem();

Vue.use(Cube);
Vue.use(LoadingPlugin);
Vue.use(AlertPlugin);
Vue.use(WechatPlugin);
Vue.use(ToastPlugin).use(ConfirmPlugin);
Vue.use(VueDND);



let baseUrl='https://gs.gaishitongshu.cn/'


console.log(process.env.NODE_ENV)
axios.defaults.baseURL=baseUrl;
axios.defaults.headers['Content-Type']='application/json;charset=utf-8'


axios.interceptors.request.use((config)=>{
console.log('request',config);
startLoading(config.url);

if(Vue.$cookies.isKey('token')){
if(config.method=='get'){

}else if(config.method=='post'){
if(config.headers['Content-Type']!='multipart/form-data'){
config.data = {
...config.data,

user_key: Vue.$cookies.isKey('token')?Vue.$cookies.get('token'):'',
}
}
}

}
return config;
},err=>{
return Promise.reject(err);
})

import whitelist from './common/ignore-url';

axios.interceptors.response.use(async response=>{
console.log('axios:',response);
endLoading(response.config.url);
if(response.config.method==='options'){
return response;
}

if(window.debug){
return response;
}

if(response.data.status!=1&&response.config.url!='https://log.yushao.net/api/addlog'){




if(response.data.msg=='请登录'){

store.dispatch('logout');
if(response.config.url==`${baseUrl}xcx/User/codeEnter`){
router.replace({name:'register',query:{from:'qrcode'}})
}else{
router.replace({name:'register'});
}

}else{
if(whitelist(baseUrl,response.config.url)){
return Promise.reject(response);
}
Vue.$vux.alert.show({
title:'错误',
content:response.data.msg?response.data.msg:'服务端发生不可预料的错误',
'dialog-transition':'vux-dialog'
})




}

return Promise.reject(response);
}
return response
},err=>{
endLoading('');
return Promise.reject(err);
})

Vue.use(vueaxios,axios);



function checkSystem(){
if(window.__wxjs_is_wkwebview){         //ios
if(window.enterUrl==''||window.enterUrl==undefined){

window.enterUrl=location.href;


}
return 'ios';
}else{                  //anzhuo
return 'anzhuo';
}
}


var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 

var jsApiList=[
'chooseImage',
'chooseWXPay',
'startRecord',
'stopRecord',
'uploadVoice',
'getLocation',
'showMenuItems',
'onMenuShareAppMessage',
'onMenuShareTimeline'
]

router.afterEach((to,from)=>{
let url=checkSystem()=='ios'?window.enterUrl:`${window.location.protocol}//${window.location.host}${to.fullPath}`;

axios.post('/Xcx/Login/getJssdk',{url}).then(res=>{       //每次跳转刷新jssdk配置
Vue.wechat.config({
...res.data.sign,

debug:false,
jsApiList:jsApiList
});
})

})






























router.beforeEach((to,from,next)=>{
if(to.meta.title){

}
console.log('userinfo',store.state.user_info);
if(from.name=='tutorial'&&to.name!='register'&&to.name!='mine'){     //点击首页所有按钮在未绑定手机时跳转绑定
if(!store.state.user_info.phone){
router.push({name:'register'});
}
}
if(!VueCookies.isKey('token')&&!getParam('code')){
let query=qs.stringify(to.query,{filter:['from']});
var encodeurl=encodeURIComponent(`${location.protocol}//${location.host}${to.path}?${query}`);
let appid='wxab0282ef768c18ac';
if(process.env.NODE_ENV=='test'){
appid='wxab0282ef768c18ac';
}
location.assign(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`);
}
rem();    
console.log('from',from.name,'to',to.name);
if(window.debug){
return next();
}

if(from.name=='tutorial'||from.name=="mine"||from.name=='login'){
if(to.name=='login'||to.name=='mine'||to.name=='tutorial'||to.name=='verification'||to.name=='register'){
next();
}else{
Vue.wechat.miniProgram.getEnv((res)=>{
if(res.miniprogram){
console.log(res.miniprogram);
Vue.wechat.miniProgram.navigateTo({url:`/pages/realpage/realpage?url=${to.fullPath}`});
}else{
next();
}
})
}

}else{
next();
}


})


/* eslint-disable no-new */
window.vue=new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})




function getParam(name) {
var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
var r = location.search.substr(1).match(reg);
if (r != null) return unescape(decodeURI(r[2]));
return null;
}





// WEBPACK FOOTER //
// ./src/main.js